//@flow
import Constants from '../constants';
import Dispatcher from '../dispatcher';

export default {
  addNotification(name:string, value:Object) {
    Dispatcher.dispatchAction(Constants.ADD_NOTIFICATION, { name, value });
  },

  clearNotification(name:string) {
    Dispatcher.dispatchAction(Constants.CLEAR_NOTIFICATION, { name });
  },
};
